import {
  toResponseError,
  type QuizData,
  type QuizId,
  type QuizUpdateInput,
  type QuizUpdateSuccess,
} from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useQuizCache } from './cache'

export function useRestoreQuiz(): UpdateHookResponse<QuizId, QuizData> {
  const mutation = useTantalimMutation<QuizUpdateInput, QuizUpdateSuccess>({
    url: '/quiz/update',
  })
  const cache = useQuizCache()

  async function restore(quizId: QuizId): Promise<QuizData> {
    try {
      const { quiz } = await mutation.mutateAsync({ quiz: { quizId, isDeleted: false } })
      // Restoring moves the quiz from the archived list to the active one,
      // which patching the cached rows in place cannot express
      cache.clearList()
      cache.clearItem(quizId)
      return quiz
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, restore)
}
